<div class="price-detail">
  <dl class="price-detail__meta">
    <dt>{{ 'inventory.priceCalculation.method' | translate }}</dt>
    <dd>{{ methodLabel }}</dd>

    <dt>{{ 'inventory.priceCalculation.aggregation' | translate }}</dt>
    <dd>{{ aggregationLabel }}</dd>

    <dt>{{ 'inventory.priceCalculation.matchCriteria' | translate }}</dt>
    <dd>{{ matchCriteriaLabel }}</dd>

    <dt>{{ 'inventory.priceCalculation.matchedOn' | translate }}</dt>
    <dd>{{ matchedOnLabel }}</dd>

    <dt>{{ 'inventory.priceCalculation.candidateCount' | translate }}</dt>
    <dd>{{ candidateCountLabel }}</dd>
  </dl>

  <ng-container *ngIf="details?.origin === 'internal'">
    <h5>{{ 'inventory.priceCalculation.references' | translate }}</h5>
    <ul class="price-detail__refs">
      <li *ngFor="let ref of references; trackBy: trackByReference"
          class="price-detail__ref">
        <a *ngIf="ref.item_uid; else plainId"
           class="price-detail__ref-id price-detail__ref-id--link"
           [href]="referenceUrl(ref.item_uid)"
           target="_blank"
           rel="noopener"
           [title]="'inventory.priceCalculation.openItem' | translate">
          {{ ref.item_uid }}
        </a>
        <ng-template #plainId>
          <span class="price-detail__ref-id">{{ ref.item_id || '–' }}</span>
        </ng-template>
        <span class="price-detail__value">
          {{ ref.value | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}
        </span>
      </li>
      <li *ngIf="references.length === 0"
          class="price-detail__no-refs">
        {{ 'inventory.priceCalculation.noReferences' | translate }}
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="details?.origin === 'gpt'">
    <h5>{{ 'inventory.priceCalculation.links' | translate }}</h5>
    <ul class="price-detail__links">
      <li *ngFor="let link of links"
          class="price-detail__link">
        <a [href]="link.url"
           target="_blank"
           rel="noopener">{{ link.url }}</a>
        <span *ngIf="link.verified"
              class="price-detail__link-badge"
              [title]="'inventory.priceCalculation.linkVerifiedHint' | translate">
          {{ 'inventory.priceCalculation.linkVerified' | translate }}
        </span>
      </li>
      <li *ngIf="links.length === 0"
          class="price-detail__no-refs">
        {{ 'inventory.priceCalculation.noLinks' | translate }}
      </li>
    </ul>
  </ng-container>

  <ng-container *ngIf="details?.origin === 'geizhals'">
    <h5>{{ 'inventory.priceCalculation.geizhalsStats' | translate }}</h5>
    <dl class="price-detail__meta">
      <dt>{{ 'inventory.priceCalculation.product' | translate }}</dt>
      <dd>{{ $any(details?.extra).product_name || '–' }}</dd>

      <ng-container *ngIf="$any(details?.extra).product_url as productUrl">
        <dt>{{ 'inventory.priceCalculation.geizhalsFields.url' | translate }}</dt>
        <dd>
          <a [href]="productUrl"
             target="_blank"
             rel="noopener">{{ productUrl }}</a>
        </dd>
      </ng-container>

      <dt>{{ 'inventory.priceCalculation.windowDays' | translate }}</dt>
      <dd>{{ $any(details?.extra).window_days ?? '–' }}</dd>

      <dt>{{ 'inventory.priceCalculation.windowRange' | translate }}</dt>
      <dd>
        <ng-container *ngIf="$any(details?.extra).window_point_count; else noWindow">
          {{ $any(details?.extra).window_min | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}
          – {{ $any(details?.extra).window_max | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}
          ({{ $any(details?.extra).window_point_count }})
        </ng-container>
        <ng-template #noWindow>–</ng-template>
      </dd>

      <ng-container *ngIf="$any(details?.extra).stats as stats">
        <dt>{{ 'inventory.priceCalculation.geizhalsFields.firstPrice' | translate }}</dt>
        <dd>{{ stats.firstPrice | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</dd>

        <dt>{{ 'inventory.priceCalculation.geizhalsFields.lastPrice' | translate }}</dt>
        <dd>{{ stats.lastPrice | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</dd>

        <dt>{{ 'inventory.priceCalculation.geizhalsFields.lowestPrice' | translate }}</dt>
        <dd>{{ stats.lowestPrice | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</dd>

        <dt>{{ 'inventory.priceCalculation.geizhalsFields.highestPrice' | translate }}</dt>
        <dd>{{ stats.highestPrice | currency : 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }}</dd>

        <dt>{{ 'inventory.priceCalculation.geizhalsFields.priceDifferencePercent' | translate }}</dt>
        <dd>{{ stats.priceDifferencePercent | number : '1.0-2' : 'de-DE' }} %</dd>
      </ng-container>
    </dl>
  </ng-container>

  <ng-container *ngIf="details?.origin === 'rg-calculated'">
    <h5>{{ 'inventory.priceCalculation.rgDetail.title' | translate }}</h5>
    <dl class="price-detail__meta">
      <dt>{{ 'inventory.priceCalculation.rgDetail.valuationDate' | translate }}</dt>
      <dd>{{ $any(details?.extra).valuation_date | date : 'dd.MM.yyyy' }}</dd>

      <dt>{{ 'inventory.priceCalculation.rgDetail.acquisitionDate' | translate }}</dt>
      <dd>{{ $any(details?.extra).acquisition_date | date : 'dd.MM.yyyy' }}</dd>

      <dt>{{ 'inventory.priceCalculation.rgDetail.priceIndex' | translate }}</dt>
      <dd>
        {{ $any(details?.extra).price_index | number : '1.0-2' : 'de-DE' }}
        ({{ $any(details?.extra).price_index_year }})
      </dd>
    </dl>

    <div *ngFor="let section of breakdown"
         class="price-detail__breakdown">
      <h6>{{ section.titel }}</h6>
      <div class="price-detail__formula">{{ section.formel }}</div>
      <div class="price-detail__formula price-detail__formula--filled">{{ section.berechnung }}</div>
      <dl class="price-detail__meta">
        <ng-container *ngFor="let kv of section.werte | keyvalue : keepOrder">
          <dt>{{ kv.key }}</dt>
          <dd>{{ kv.value }}</dd>
        </ng-container>
      </dl>
    </div>
  </ng-container>
</div>